import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AuthProvider as DescopeAuthProvider } from '@descope/react-sdk';
import { theme } from '@/theme';
import { AuthProvider } from '@/features/auth/AuthContext';
import App from '@/app/App';
import './theme/fonts.css';

// Descope must wrap our AuthProvider — our provider reads Descope's hooks
// (useSession/useUser/useDescope), so it needs to be inside DescopeAuthProvider.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DescopeAuthProvider projectId={import.meta.env.VITE_DESCOPE_PROJECT_ID as string}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </DescopeAuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
